import React from "react";
import Entities from "../../components/Entities";

function Stores() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "stores",
        allowExport: true,
        fields: [
          {
            name: "Banner",
            propertyName: "banner",
            isObject: true,
            filter: true,
            filterRoute: "banners",
          },
          {
            name: "Store No",
            propertyName: "number",
            search: true,
          },
          {
            name: "Visit Frequency",
            propertyName: "visitFrequency",
          },
          {
            name: "City",
            propertyName: "city",
          },
          {
            name: "Address",
            propertyName: ["civicNo", "street", "city"],
          },
          {
            name: "Status",
            propertyName: "status",
            filter: true,
            hidden: true,
            filterOptions: [
              { label: "Active", value: "ACTIVE" },
              { label: "Inactive", value: "INACTIVE" },
            ],
          },
          {
            name: "Territory",
            propertyName: "territory",
            isObject: true,
            filter: true,
            filterRoute: "territories",
          },
        ],
      }}
    />
  );
}

export default Stores;
